import ActionTypeEnum from "../enums/ActionTypeEnum";
import Action from "../interfaces/Action";
import ClientData from "../interfaces/ClientData";

const initialState = window.onnit_context?.client ?? null;

export default function clientReducer(state: ClientData | null = initialState, action: Action) {
    switch (action.type) {
        case ActionTypeEnum.CLIENT_DATA_SET:
            return action.clientData;
        default:
            return state;
    }
}
